import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5648f50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5648f50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5648f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5648f50')) {
      api.createRecord('a5648f50', component.options)
    } else {
      api.reload('a5648f50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a5648f50&scoped=true", function () {
      api.rerender('a5648f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JumpNative/index.vue"
export default component.exports